// Zusätzliche Übersetzungen (flache Schlüssel wie in de.js); wird in fieldMapping.js über die Basis-Sprachdateien gelegt.
const de = {};
const en = {};
const tr = {};
const pl = {};
const uk = {};
const all = { de, en, tr, pl, uk };
export default all;
